import React from 'react'

import * as HoverCard from '@radix-ui/react-hover-card'

import useTranslation from '../../context/hooks/useTranslation'
import isToday from '../../lib/utils/isToday'
import { ReturnShipmentDataResponse } from '../../types/SetShipmentAsReturn'
import WarnIcon from '../../vectors/WarnIcon'

export interface ShipmentInfoButtonProps {
  returnInfo: ReturnShipmentDataResponse
  merchantName: string
  onClick: () => void
}

export const ShipmentForReturnInfoButton: React.FC<ShipmentInfoButtonProps> = ({
  onClick,
  returnInfo,
  merchantName,
}) => {
  const { t, trans: Trans } = useTranslation()

  return (
    <HoverCard.Root openDelay={200} closeDelay={0}>
      <HoverCard.Trigger asChild>
        <button
          type="button"
          onClick={onClick}
          className="hover:bg-gray-34 flex h-8 w-8 cursor-pointer flex-row items-center justify-center rounded-sm"
        >
          <WarnIcon small />
        </button>
      </HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content
          align="start"
          side="right"
          className="shadow-elevation-2 rounded-[4px] bg-white p-2"
        >
          <div className="bg-yellow-light-fade flex flex-row gap-2 rounded-[4px] px-4 py-2">
            <WarnIcon />
            {isToday(returnInfo.day) ? (
              <div className="font-body text-md flex flex-col text-indigo-50">
                <div className="flex flex-row gap-1">
                  {t('RETURNS_SCAN.RETURN_TODAY_TO')}
                  <span className="font-heading">{merchantName}</span>
                </div>
                <div className="flex flex-row gap-1">
                  {t('RETURNS_SCAN.COLLECTION_OPT_ID')}
                  <span className="font-heading">
                    {returnInfo.optimizationTourId}
                  </span>
                </div>
                <div className="flex flex-row gap-1">
                  {t('RETURNS_SCAN.COLLECTION_TOUR_TAG')}
                  <span className="font-heading">{returnInfo.tourTag}</span>
                </div>
              </div>
            ) : (
              <div className="font-body text-md text-indigo-40 max-w-[394px]">
                <Trans
                  t={t}
                  i18nKey="RETURNS_SCAN.NO_COLLECTION_TODAY"
                  values={{
                    merchantName,
                    day: returnInfo.day,
                    optimizationId: returnInfo.optimizationTourId,
                    tourTag: returnInfo.tourTag,
                  }}
                  components={{
                    b: <span className="font-heading" />,
                  }}
                />
              </div>
            )}
          </div>
          <HoverCard.Arrow className="stroke-gray-42 fill-white" />
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  )
}

export default ShipmentForReturnInfoButton
